// @flow
import React from 'react';
import Group from 'sail/Group';

import {PlatformSetting} from './components/PlatformSetting';
import {ClientSetting} from './components/ClientSetting';
import {ServerSetting} from './components/ServerSetting';

export const DEFAULT_SETTINGS = {
  platforms: ['web', 'ios', 'android'],
  clients: {
    web: ['html', 'react'],
    ios: ['swift'],
    android: ['kotlin', 'java'],
  },
  servers: ['ruby', 'node', 'php', 'python', 'go', 'dotnet', 'java'],
};

export const DefaultSettings = () => {
  return (
    <Group direction="horizontal" alignItems="center" spacing={24}>
      <PlatformSetting clients={DEFAULT_SETTINGS.clients} />
      <ClientSetting clients={DEFAULT_SETTINGS.clients} />
      <ServerSetting servers={DEFAULT_SETTINGS.servers} />
    </Group>
  );
};
